import { IconsProps } from '@/types/shared'
import React from 'react'

const HeartIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-scan-heart-icon lucide-scan-heart"
            >
                <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                <path d="M7.828 13.07A3 3 0 0 1 12 8.764a3 3 0 0 1 4.172 4.306l-3.447 3.62a1 1 0 0 1-1.449 0z" />
            </svg>
        </div>
    )
}

export default HeartIcons
